import { render } from "./AvatarUpload.vue?vue&type=template&id=fbbad79e"
import script from "./AvatarUpload.vue?vue&type=script&lang=js"
export * from "./AvatarUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__